import { isInitialPublicAuthPath, isPublicAuthPath } from "@/utils/routeFlags";

let authStylesPromise: Promise<void> | null = null;
let appStylesPromise: Promise<void> | null = null;
let elementPlusServiceStylesPromise: Promise<void> | null = null;

export function loadAuthStyles(): Promise<void> {
  if (!authStylesPromise) {
    authStylesPromise = import(
      /* webpackChunkName: "auth-shared" */ "@/assets/style/auth.scss"
    ).then(() => undefined);
  }

  return authStylesPromise;
}

export function loadElementPlusServiceStyles(): Promise<void> {
  if (!elementPlusServiceStylesPromise) {
    elementPlusServiceStylesPromise = Promise.all([
      import("element-plus/es/components/loading/style/css"),
      import("element-plus/es/components/message/style/css"),
      import("element-plus/es/components/message-box/style/css"),
      import("element-plus/es/components/notification/style/css"),
    ]).then(() => undefined);
  }

  return elementPlusServiceStylesPromise;
}

export function loadAppStyles(): Promise<void> {
  if (!appStylesPromise) {
    // โหลด Element Plus ก่อน แล้วค่อย app styles — ถ้าใช้ Promise.all ลำดับ <style> ไม่แน่นอน
    // ทำให้ padding-bottom: 10px ของ .el-message-box มาทีหลังและทับ padding shorthand
    appStylesPromise = loadElementPlusServiceStyles()
      .then(() => import("@/assets/style/components.scss"))
      .then(() => import("@/assets/style/style.scss"))
      .then(() => undefined);
  }

  return appStylesPromise;
}

export async function loadStylesForPath(path: string): Promise<void> {
  if (isPublicAuthPath(path)) {
    await loadAuthStyles();
  }

  if (!isInitialPublicAuthPath(path)) {
    await loadAppStyles();
  }
}
